import React from 'react';
import { connect } from 'react-redux';
import { string, shape } from 'prop-types';
import cx from 'classnames';

import RouteNameDisplay from 'components/RouteNameDisplay';
import Trendline from 'components/Trendline';
import NumberDisplay from 'components/NumberDisplay';
import SpeedDisplay from 'components/SpeedDisplay';
import SpeedTrendIcon from 'components/SpeedTrendIcon';

import styles from './RoutesListItem.scss';

export function RoutesListItem({ route, sortValue, currentHover }) {
  const { from, to, status, speedLastHour, liveSpeed, travelTimeIndex } = route;
  const isReporting = status !== 'disconnected';

  const travelTimeLastHour = speedLastHour.map(v => -v);
  const speedTrend = 'up';

  const isHovered = Boolean(currentHover && currentHover.id === route.id);

  return (
    <div className={cx(styles.main, styles[`status-${status}`])}>
      <div className={styles.liveDisplay}>
        {isReporting
          ? <SpeedTrendIcon trend={speedTrend} className={styles.trendIcon} />
          : <div className={styles.statusText}>N/A</div>}
      </div>

      <RouteNameDisplay
        className={styles.route}
        fromLocationName={from.name}
        toLocationName={to.name}
        status={status}
      />

      <div className={styles.numberDisplay}>
        {sortValue === 'tti'
          ? <NumberDisplay value={travelTimeIndex} status={status} isHovered={isHovered} />
          : <SpeedDisplay value={liveSpeed} status={status} isHovered={isHovered} />}
      </div>

      <div className={styles.trendLine}>
        {sortValue === 'tti'
          ? <Trendline trendData={speedLastHour} width={48} height={27} />
          : <Trendline trendData={travelTimeLastHour} width={48} height={27} />}
      </div>
    </div>
  );
}

RoutesListItem.propTypes = {
  route: shape({ id: string }).isRequired,
  sortValue: string.isRequired,
  currentHover: shape({ id: string, type: string }),
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

const ConnectedRoutesListItem = connect(mapStateToProps)(RoutesListItem);

export default ConnectedRoutesListItem;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/RoutesListItem/index.js